var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChartAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 22C14.6851 22 18.1637 18.9754 18.8693 14.9929C19.0138 14.1772 18.3284 13.5 17.5 13.5H12C11.1716 13.5 10.5 12.8284 10.5 12V6.5C10.5 5.67157 9.82277 4.98615 9.00705 5.13068C5.02455 5.83629 2 9.31493 2 13.5C2 18.1944 5.80558 22 10.5 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.9999C21.3284 11.9999 22.0118 11.3244 21.889 10.5051C21.2406 6.17896 17.821 2.75931 13.4948 2.11089C12.6755 1.9881 12 2.6715 12 3.49993V10.9999C12 11.5522 12.4477 11.9999 13 11.9999H20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartAlt);
export default __webpack_public_path__ + "static/media/pie-chart-alt.c52845c0fa71eda367725c3776363bad.svg";
export { ForwardRef as ReactComponent };